/* 🤖 this file was generated by svg-to-ts */
export const matIconPentagon: {
  name: 'pentagon';
  data: string;
} = {
  name: 'pentagon',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.63 9.78 16.56 19H7.44L4.37 9.78 12 4.44l7.63 5.34zM2 9l4 12h12l4-12-10-7L2 9z"/></svg>`
};
